export const DATA_SOURCE_REGISTRY = [
  // STUDENT CATEGORY
  { key: 'student.name', label: 'Student Full Name', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.studentId', label: 'Student System ID', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.admissionNo', label: 'Admission Number', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.rollNo', label: 'Roll Number', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.scholarNo', label: 'Scholar Number', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.className', label: 'Class Name', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.section', label: 'Section Name', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.dob', label: 'Date of Birth', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.gender', label: 'Gender', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.category', label: 'Student Category', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.medium', label: 'Medium of Instruction', category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.fatherName', label: "Father's Name", category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.motherName', label: "Mother's Name", category: 'STUDENT', dataType: 'TEXT' },
  { key: 'student.photo', label: 'Student Photo', category: 'STUDENT', dataType: 'IMAGE' },

  // ACADEMIC CATEGORY
  { key: 'subject.name', label: 'Subject Name', category: 'ACADEMIC', dataType: 'TEXT' },
  { key: 'subject.code', label: 'Subject Code', category: 'ACADEMIC', dataType: 'TEXT' },
  { key: 'assessment.maxMarks', label: 'Maximum Marks', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.obtainedMarks', label: 'Obtained Marks', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.fa1', label: 'Formative Assessment 1 (FA-1)', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.fa2', label: 'Formative Assessment 2 (FA-2)', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.sa1', label: 'Summative Assessment 1 (SA-1)', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.fa3', label: 'Formative Assessment 3 (FA-3)', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.fa4', label: 'Formative Assessment 4 (FA-4)', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.sa2', label: 'Summative Assessment 2 (SA-2)', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.periodicTest', label: 'Periodic Test (PT)', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.notebook', label: 'Notebook Marks', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.subjectEnrichment', label: 'Subject Enrichment (SEA)', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.halfYearly', label: 'Half Yearly Exam Marks', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'assessment.yearly', label: 'Yearly / Final Exam Marks', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'result.theoryMarks', label: 'Theory Component Marks', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'result.practicalMarks', label: 'Practical Component Marks', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'result.internalMarks', label: 'Internal Assessment Marks', category: 'ACADEMIC', dataType: 'MARK' },
  { key: 'subject.credits', label: 'Course Credits', category: 'ACADEMIC', dataType: 'MARK' },

  // CALCULATED CATEGORY
  { key: 'calculated.total', label: 'Total Marks', category: 'CALCULATED', dataType: 'MARK' },
  { key: 'calculated.percentage', label: 'Overall Percentage (%)', category: 'CALCULATED', dataType: 'PERCENTAGE' },
  { key: 'calculated.grade', label: 'Subject / Overall Grade', category: 'CALCULATED', dataType: 'GRADE' },
  { key: 'calculated.cgpa', label: 'CGPA Score', category: 'CALCULATED', dataType: 'MARK' },
  { key: 'calculated.sgpa', label: 'SGPA Score', category: 'CALCULATED', dataType: 'MARK' },

  // ATTENDANCE CATEGORY
  { key: 'attendance.workingDays', label: 'Total Working Days', category: 'ATTENDANCE', dataType: 'MARK' },
  { key: 'attendance.presentDays', label: 'Days Present', category: 'ATTENDANCE', dataType: 'MARK' },
  { key: 'attendance.absentDays', label: 'Days Absent', category: 'ATTENDANCE', dataType: 'MARK' },
  { key: 'attendance.percentage', label: 'Attendance Percentage (%)', category: 'ATTENDANCE', dataType: 'PERCENTAGE' },

  // RESULT CATEGORY
  { key: 'result.status', label: 'Result Status (PASS/FAIL)', category: 'RESULT', dataType: 'TEXT' },
  { key: 'result.rank', label: 'Class / Section Rank', category: 'RESULT', dataType: 'TEXT' },
  { key: 'result.division', label: 'Passed Division', category: 'RESULT', dataType: 'TEXT' },
  { key: 'result.promotionClass', label: 'Promoted To Class', category: 'RESULT', dataType: 'TEXT' }
];

export const getRegistryByCategory = (category) => {
  return DATA_SOURCE_REGISTRY.filter(item => item.category === category);
};
